<template>
  <div class="mobileHomePage">
    <div class="topHeader">
      <img src="./img/icon_logo.png" />
      <span>CaptarCash</span>
    </div>
    <div class="topBanner">
      <swiper :options="swiperOption">
        <swiperSlide>
          <div class="swiper-item">
            <img src="./img/mobile/top_banner1.png" alt />
          </div>
        </swiperSlide>
        <swiperSlide>
          <div class="swiper-item">
            <img src="./img/mobile/top_banner2.png" alt />
          </div>
        </swiperSlide>
        <swiperSlide>
          <div class="swiper-item">
            <img src="./img/mobile/top_banner3.png" alt />
          </div>
        </swiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="downloadAppBtn" @click="download">
        <button class="download-button">DESCARGA APP</button>
      </div>
    </div>
    <div class="ourAdvantage">
      <div class="contentWrap">
        <dl>
          <dt>Nuestras ventajas</dt>
          <dd class="img-left">
            <img src="./img/mobile/goodAt_01.png" alt />
            <div>
              <b>Préstamo rápido</b>
              <span
                >en 8 minutos puedes aprobar tu solicitud y en 1 hora puedes
                tenerlo en tu propia cuenta.</span
              >
            </div>
          </dd>
          <dd class="img-right">
            <img src="./img/mobile/goodAt_03.png" alt />
            <div>
              <b>Experiencia en línea fluidamente</b>
              <span
                >Subiendo tu ID válido terminas tu solicitud en línea, no más
                papeleo!</span
              >
            </div>
          </dd>
        </dl>
      </div>
    </div>
    <div class="centerBanner">
      <swiper :options="swiperOption">
        <swiperSlide>
          <div class="swiper-item">
            <h5>4 pasos fáciles para obtener dinero en 1 hora</h5>
            <h6>1.Regístrate con tu celuar android</h6>
            <img src="./img/mobile/center_banner1.png" alt />
          </div>
        </swiperSlide>
        <swiperSlide>
          <div class="swiper-item">
            <h5>4 pasos fáciles para obtener dinero en 1 hora</h5>
            <h6>2.Sube tu ID información, no más papeleo</h6>
            <img src="./img/mobile/center_banner2.png" alt />
          </div>
        </swiperSlide>
        <swiperSlide>
          <div class="swiper-item">
            <h5>4 pasos fáciles para obtener dinero en 1 hora</h5>
            <h6>3.Aprueba tu solicitud</h6>
            <img src="./img/mobile/center_banner3.png" alt />
          </div>
        </swiperSlide>
        <swiperSlide>
          <div class="swiper-item">
            <h5>4 pasos fáciles para obtener dinero en 1 hora</h5>
            <h6>
              4.Tu préstamo será transferido dentro de 1 hora( depende de la
              forma de recibirlo que elegiste)
            </h6>
            <img src="./img/mobile/center_banner4.png" alt />
          </div>
        </swiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="useAppStep">
      <ul class="stepList">
        <li class="stepItem">
          <img src="./img/mobile/center_step1.png" alt />
          <div class="stepTitle">Descarga la APP Captarcash</div>
          <div class="stepDesc">
            Regístrate con tu celuar android y sube tu información personal (ID
            y información del trabajo).
          </div>
        </li>
        <li class="stepItem">
          <img src="./img/mobile/center_step2.png" alt />
          <div class="stepTitle">Velificación automáticamente en línea</div>
          <div class="stepDesc">
            Rápido que cualquiera otra plataforma de préstamos(130 minutos).
          </div>
        </li>
        <li class="stepItem">
          <img src="./img/mobile/center_step3.png" alt />
          <div class="stepTitle">
            Las comisiones totalmente transparente y descripción de los terminos
            y condiciones claramente
          </div>
          <div class="stepDesc">
            Las comisiones están escritos en los terminos y condiciones.
          </div>
        </li>
        <li class="stepItem">
          <img src="./img/mobile/center_step4.png" alt />
          <div class="stepTitle">
            El sistema de verificación es súper eficiente, Para cada solicitud
            te dan la respuesta dentro de 1 hora.
          </div>
          <div class="stepDesc"></div>
        </li>
      </ul>
    </div>
    <div class="normalQuestion">
      <h3>FAQ</h3>
      <ul class="questionList">
        <li class="questionItem">
          <h6>
            <img src="./img/mobile/question_title1.png" alt />
            <span>Nuestras ventajas</span>
          </h6>
          <div class="questionQ">P: Cuánto tiempo tarda el registro?</div>
          <div class="questionA">
            R: Con celular android, puedes terminar el registro en 1 solo minuto
            Aplicación.
          </div>
        </li>
        <li class="questionItem">
          <h6>
            <img src="./img/mobile/question_title2.png" alt />
            <span>Aplicación</span>
          </h6>
          <div class="questionQ">P: Cómo usar?</div>
          <div class="questionA">
            R: Register using your android phone and submit needed information
            (ID, job information)
          </div>
        </li>
        <li class="questionItem">
          <h6>
            <img src="./img/mobile/question_title3.png" alt />
            <span>Requerimiento</span>
          </h6>
          <div class="questionQ">
            P: Qué es el requisito para usar Captarcash?
          </div>
          <div class="questionA">R: Mexicano, más de 18 años Convenios.</div>
        </li>
        <li class="questionItem">
          <h6>
            <img src="./img/mobile/question_title4.png" alt />
            <span>Convenios</span>
          </h6>
          <div class="questionQ">P: Cómo puedo obtener el dinero?</div>
          <div class="questionA">
            R: Puedes elegir una cuenta bancaria o directamente los locales para
            retirarlo en efectivo.
          </div>
        </li>
      </ul>
    </div>
    <div class="aboutUs">
      <h5>Sobre nosotros</h5>
      <img src="./img/mobile/aboutUs_bg.png" alt />
      <span>
        Capatarcash es una plataforma financiera para ofrecer préstamos en
        cualquier momento y cualquier lugar. Nuestro servicio es en base de
        Seguridad de Internet
      </span>
    </div>
    <div class="contactUs">
      <h5>contáctanos</h5>
      <h6 @click="sendMail">captarcash@la-weshare.com</h6>
    </div>
    <div class="pageFooter">
      <img src="./img/icon_facebook.png" alt @click="toFaceBook" />
      <span class="faceBookTitle" @click="toFaceBook">FaceBook</span>
      <h1 class="footer-company-name">Monmar Tecnología S.de R.L.</h1>
      <h1 class="footer-company-name">Teléfono: +52 5541609932</h1>
      <address>
        Direccion: paseo de la reforma 42 número int. 1ER piso OF.A colonia
        Juárez, delegación Cuauhtémoc, CDMX
      </address>
    </div>
    <!-- <div class="pageFooter">
      <img src="./img/mobile/mobile_footer.png" />
    </div>-->
  </div>
</template>
<script>
// eslint-disable-next-line
import "swiper/dist/css/swiper.css"; // //这里注意具体看使用的版本是否需要引入样式，以及具体位置。
// eslint-disable-next-line
import { swiper, swiperSlide } from "vue-awesome-swiper";
// eslint-disable-next-line
import {
  getStoreUuid,
  getUgid,
  getSessionId,
  isIos,
  getParamSearchByName,
  wakeupApp,
} from "@/utils/tool";
// eslint-disable-next-line
import { dataAcq } from "@/utils/dataAcquisition";

const androidToIOSChannelMap = {
  1000001001: "1000301001",
  1000001002: "1000301002",
  // 官网默认下载链接
  1000288004: "1000388005",
};

export default {
  name: "mobileHome",
  data() {
    return {
      swiperOption: {
        autoplay: {
          disableOnInteraction: false,
        },
        speed: 500,
        paginationClickable: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          paginationClickable: true,
        },
        preventClicksPropagation: true,
      },
      ACQdata: [
        {
          mid: "ACQ01",
          path: "/",
          referId: "phWebHome",
          pageId: "phWebHome",
          btnId: "",
          appid: "jk",
          ctime: this.createdTime,
          zuid: getStoreUuid(),
          swv: "ph_1.0.0.0",
          ugid: getUgid(),
          ch_biz: "jk",
          district: "ph",
          appver: "1.0.0",
          version: "1.0",
          tokenId: getUgid(),
          sessionId: getSessionId(),
          ch_sub: "2",
        },
      ],
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    dataAcq(this.ACQdata);
    const channel = getParamSearchByName("channel");
    this.channelType = this.getRealChannel(
      !channel || channel === "null" ? "1000288004" : channel
    );
  },
  methods: {
    download() {
      // let url = '';
      // if (isIos()) {
      //   url = 'https://apps.apple.com/us/app/pondopeso/id1465541253?l=zh&ls=1';
      // } else {
      //   url = 'https://s3pub.pondopeso.com/pondopeso--1000200014-release-v1.0.8.6-16779271-20190418-145848-Website.apk';
      // }
      // const iframe = document.createElement('iframe');
      // iframe.src = url;
      // iframe.style.display = 'none';
      // document.body.appendChild(iframe);
      // window.location.href = 'https://manila.pek3a.qingstor.com/apk/pondopeso--1000200014-release-v1.0.8.6-16779271-20190418-145848-Website.apk';
      const data = [
        {
          mid: "ACQ03",
          eleId: "phWebHomedownloadApp",
          clickTime: new Date().getTime(),
          appid: "jk",
          ctime: new Date().getTime(),
          zuid: getStoreUuid(),
          swv: "ph_1.0.0.0",
          path: "/",
          ugid: getUgid(),
          ch_biz: "jk",
          district: "ph",
          appver: "1.0.0",
          version: "1.0",
          tokenId: getUgid(),
          sessionId: getSessionId(),
          ch_sub: "2",
        },
      ];
      dataAcq(data);
      // window.location.href = url;
      this.downloadApp();
    },
    sendMail() {
      window.location.href = "mailto:captarcash@la-weshare.com";
    },
    toFaceBook() {
      window.location.href = "https://www.facebook.com/CaptarCash/";
    },
    getRealChannel(channel) {
      if (isIos() && androidToIOSChannelMap[channel]) {
        return androidToIOSChannelMap[channel];
      }
      return channel;
    },
    downloadApp() {
      if (this.channelType) {
        if (isIos()) {
          location.href = `https://play.google.com/store/apps/details?id=id.captarcash.weshare.jiekuan`;
        } else {
          // location.href = `https://play.google.com/store/apps/details?id=id.captarcash.weshare.jiekuan`;
          const downloadUrl = "https://s3u.captarcash.com/CaptarCash.apk";
          const downloadLink = document.createElement("a");
          downloadLink.setAttribute("download", true);
          downloadLink.setAttribute("href", downloadUrl);
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.click();
        }
      } else {
        wakeupApp();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
px = (1 / 3.75vw);

.mobileHomePage {
  background: #ffffff;

  /deep/ .swiper-pagination-bullet-active {
    background: #ff8900;
  }

  .topHeader {
    img {
      margin: 0 px * 15;
      width: px * 30;
      vertical-align: middle;
    }

    line-height: px * 44;
    background: #FF9300;
    font-weight: 600;
    font-size: px * 18;
    color: #fff;
  }

  .topBanner {
    height: px * 270;
    width: 100%;
    position: relative;

    .swiper-item {
      img {
        display: block;
        width: 100%;
      }
    }

    .swiper-pagination {
      bottom: 45 * px;
    }

    .downloadAppBtn {
      position: absolute;
      height: px * 32;
      top: px * 185;
      right: 0;
      line-height: px * 28;
      font-size: px * 14;
      // box-shadow: 0px 5 * px 11 * px 0px rgba(1, 8, 16, 0.05);
      border-radius: 14 * px;
      padding: 0 15 * px;
      color: #007FFF;
      z-index: 10;

      .download-button {
        background: #fff;
        border: 0;
        outline: none;
        padding: 10px 20px;
        border-radius: 30px;
        box-shadow: 0 2px 0px 2px #ff7b34;
        color: #f56505;
        font-size: 3.2vw;
        cursor: pointer;
      }
    }
  }

  .ourAdvantage {
    background: #f7f7f7;
    padding-bottom: 30px;

    .contentWrap {
      position: relative;
      z-index: 9;
      background: #ffffff;
      margin-top: -30 * px;
      border-radius: 4 * px;
      margin-left: 10 * px;
      margin-right: 10 * px;

      dl {
        overflow: hidden;

        // margin-bottom 30*px
        dt {
          padding-top: 40 * px;
          padding-bottom: 30 * px;
          text-align: center;
          font-size: 16 * px;
          line-height: 22 * px;
          color: #32325C;
          font-weight: 600;
        }

        dd {
          padding: 0 40 * px;
          overflow: hidden;
          margin-bottom: 40 * px;

          img {
            width: 65 * px;
            float: left;
          }

          div {
            float: left;
            width: 160 * px;
            margin-left: 40 * px;

            b {
              line-height: 20 * px;
              color: #031D5B;
              font-weight: 600;
              font-size: 14 * px;
              display: block;
            }

            span {
              line-height: 20 * px;
              font-size: 12 * px;
              color: #5B6C94;
            }
          }

          &.img-right {
            div {
              margin-left: 0;
              margin-right: 40 * px;
            }

            img {
              float: inherit;
            }
          }
        }
      }
    }
  }

  .centerBanner {
    background: #ffffff;

    .swiper-item {
      position: relative;

      img {
        display: block;
        width: 100%;
      }

      h5 {
        position: absolute;
        left: 16 * px;
        top: 30 * px;
        font-size: 16 * px;
        font-weight: 600;
        line-height: 22 * px;
        width: 190 * px;
        color: #32325C;
        text-align: center;
      }

      h6 {
        position: absolute;
        left: 16 * px;
        top: 94 * px;
        width: 190 * px;
        font-size: 14 * px;
        color: #5B6C94;
        line-height: 14 * px;
      }
    }
  }

  .useAppStep {
    margin-top: 65 * px;
    overflow-y: auto;
    width: 100%;

    .stepList {
      width: 318 * 4 * px;
      overflow: hidden;
      padding-bottom: 20 * px;
    }

    .stepItem {
      width: 288 * px;
      margin: 0 15 * px;
      padding-top: 25 * px;
      padding-top: 12 * px;
      height: 290 * px;
      background: #fff;
      float: left;
      box-shadow: 0px 1 * px 7 * px 0px rgba(0, 0, 0, 0.12);
      border-radius: 4 * px;

      img {
        display: block;
        width: 120 * px;
        margin: 0 auto;
      }

      div {
        line-height: 28 * px;
        color: #32325C;
        font-weight: 400;
        font-size: 12 * px;
        text-align: center;
        padding: 0 12 * px;

        &.stepTitle {
          margin-top: 15 * px;
        }
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .normalQuestion {
    h3 {
      line-height: 22 * px;
      font-size: 16 * px;
      color: #32325C;
      font-weight: 600;
      padding-top: 20 * px;
      padding-bottom: 20 * px;
      text-align: center;
    }

    .questionList {
      overflow: hidden;

      .questionItem {
        float: left;
        height: 196 * px;
        background: #FFF7ED;
        border-radius: 4 * px;
        border: 1px solid #ff9300;
        margin-left: 12 * px;
        width: 170 * px;
        margin-bottom: 15 * px;

        h6 {
          text-align: center;
          line-height: 18 * px;
          font-size: 12 * px;
          font-weight: bolder;
          color: #32325C;
          padding-top: 20 * px;
          padding-bottom: 15 * px;

          img {
            height: 18 * px;
            margin-right: 10 * px;
            vertical-align: middle;
          }
        }

        div {
          padding: 0 8 * px;
          color: #5B6C94;
          font-size: 12 * px;
          line-height: 16 * px;

          &.questionQ {
            margin-bottom: 12 * px;
          }
        }
      }
    }
  }

  .aboutUs {
    position: relative;
    margin: 0 10 * px;

    h5 {
      text-align: center;
      color: #32325C;
      font-size: 16 * px;
      font-weight: 600;
      line-height: 22 * px;
      padding-top: 40 * px;
      padding-bottom: 20 * px;
    }

    img {
      display: block;
      width: 100%;
      border-radius: 4 * px;
    }

    span {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 14 * px;
      color: #fff;
      font-size: 10 * px;
      line-height: 16 * px;
      background: rgba(0, 0, 0, 0.5);
    }
  }

  .contactUs {
    padding: 40 * px 0;
    text-align: center;

    h5 {
      font-size: 16 * px;
      font-weight: 600;
      color: rgba(50, 50, 92, 1);
      line-height: 22 * px;
      padding-bottom: 10 * px;
    }

    h6 {
      font-size: 14 * px;
      font-weight: 600;
      line-height: 20 * px;
    }
  }

  .pageFooter {
    width: 100%;
    height: 185 * px;
    background: url('./img/mobile/footer_bg.png') no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
    text-align: center;

    img {
      width: 30 * px;
      margin-top: 30 * px;
    }

    span {
      padding-top: 5 * px;
      font-size: 12 * px;
      line-height: 17 * px;
      font-weight: 400;
      color: #fff;
      display: block;
    }

    h1 {
      text-align: center;
      line-height: 30 * px;
      color: #fff;
      font-size: 13 * px;
    }

    address {
      width: 300 * px;
      margin: 0 auto;
      margin-top: 10 * px;
      font-size: 12 * px;
      color: #EDFFFB;
      line-height: 17 * px;
      font-weight: 400;
      // margin-top 30*px
    }

    .privacyPolicy {
      margin: 0 auto;
      margin-top: 6 * px;
      font-size: 10 * px;
      font-weight: 400;

      a {
        color: #A0C6E9;
      }
    }
  }
}
</style>
